var _rect, _rect2, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutLite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1512,
    height: 1315,
    viewBox: "0 0 1512 1315",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 415,
    height: 441,
    transform: "matrix(-1 0 0 1 1182 437)",
    fill: "url(#paint0_angular_2765_3598)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 352,
    y: 437,
    width: 415,
    height: 441,
    fill: "url(#paint1_angular_2765_3598)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bf_2765_3598)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 334,
    y: 669,
    width: 844,
    height: 328,
    fill: "black",
    fillOpacity: 0.15
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_2765_3598)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 758.347,
    cy: 657.5,
    rx: 434.347,
    ry: 81.5,
    fill: "#00E194",
    fillOpacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bf_2765_3598",
    x: 234,
    y: 569,
    width: 1044,
    height: 528,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 50
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2765_3598"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2765_3598",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20,
    result: "effect2_foregroundBlur_2765_3598"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_2765_3598",
    x: -251.294,
    y: 0.705872,
    width: 2019.28,
    height: 1313.59,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 287.647,
    result: "effect1_foregroundBlur_2765_3598"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_angular_2765_3598",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(207.5 220.5) rotate(0.192817) scale(181.501 132.653)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E194"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.199303,
    stopColor: "#00B275",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.368496,
    stopColor: "#009260",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83483,
    stopColor: "#00281A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99414,
    stopColor: "#000F0A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_angular_2765_3598",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(559.5 657.5) rotate(0.192817) scale(181.501 132.653)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E194"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.199303,
    stopColor: "#00B275",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.368496,
    stopColor: "#009260",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83483,
    stopColor: "#00281A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99414,
    stopColor: "#000F0A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutLite);
export default __webpack_public_path__ + "static/media/about_lite.434ec71ee6a02d14733c7393d396ba4b.svg";
export { ForwardRef as ReactComponent };